'use client';

import { SendStepView } from './send-step-view';
import { useSendStep } from './use-send-step';
import type { BaseSendPayload, SendStepProps } from './send-step.types';

export function SendStep<TPayload extends BaseSendPayload>(
  props: SendStepProps<TPayload>
) {
  const state = useSendStep<TPayload>(props);
  return <SendStepView config={props.config} state={state} />;
}
